import firestore from "../../firebase/firestore";
export const getPowerPlants = () => {
  return firestore.collection("power_plants").get();
};
